import { HUB_TYPES } from '../utils/hubRoutes';

export const HUB_SECTIONS = [
    {
        type: HUB_TYPES.PROJECT_MANAGEMENT,
        titleKey: 'hubs.projectManagement.title',
        descriptionKey: 'hubs.projectManagement.description',
    },
    {
        type: HUB_TYPES.VENDOR,
        titleKey: 'hubs.vendor.title',
        descriptionKey: 'hubs.vendor.description',
    },
    {
        type: HUB_TYPES.CUSTOMER,
        titleKey: 'hubs.customer.title',
        descriptionKey: 'hubs.customer.description',
    },
];

export function getCreateDialogCopy({ dialogMode, hubType, parentOrg, t }) {
    if (dialogMode === 'managed') {
        const description = t('hubs.managedOrganizationDescription', {
            parentName: parentOrg?.name || '',
        });

        switch (hubType) {
            case HUB_TYPES.VENDOR:
                return {
                    title: t('hubs.createManagedVendorProfile'),
                    submit: t('hubs.createManagedVendorProfile'),
                    description,
                };
            case HUB_TYPES.CUSTOMER:
                return {
                    title: t('hubs.createManagedCustomerProfile'),
                    submit: t('hubs.createManagedCustomerProfile'),
                    description,
                };
            default:
                return {
                    title: t('hubs.createManagedOrganization'),
                    submit: t('hubs.createManagedOrganization'),
                    description,
                };
        }
    }

    switch (hubType) {
        case HUB_TYPES.VENDOR:
            return {
                title: t('hubs.createVendorProfile'),
                submit: t('hubs.createVendorProfile'),
                description: t('hubs.createVendorProfileDescription'),
            };
        case HUB_TYPES.CUSTOMER:
            return {
                title: t('hubs.createCustomerProfile'),
                submit: t('hubs.createCustomerProfile'),
                description: t('hubs.createCustomerProfileDescription'),
            };
        default:
            return {
                title: t('hubs.createOrganization'),
                submit: t('hubs.createOrganization'),
                description: t('hubs.createOrganizationDescription'),
            };
    }
}
